const facilities = [
  {
    name: "Juneau Main Post Office",
    address: "9491 Vintage Blvd, Juneau, AK 99801",
    phone: "(907) 586-7165",
    hours: "Mon–Fri 8:30am–5:00pm",
    note: "Primary passport acceptance for Juneau; photo services on site",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Downtown Juneau Post Office",
    address: "706 W 9th St, Juneau, AK 99801",
    phone: "(907) 586-7100",
    hours: "Mon–Fri 9:00am–5:00pm",
    note: "Downtown acceptance facility near State Capitol",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Mendenhall Valley Post Office",
    address: "2101 Mendenhall Loop Rd, Juneau, AK 99801",
    phone: "(907) 789-2512",
    hours: "Mon–Fri 9:00am–5:00pm",
    note: "Serving Mendenhall Valley and Auke Bay",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "City & Borough of Juneau Clerk",
    address: "155 S Seward St, Juneau, AK 99801",
    phone: "(907) 586-5278",
    hours: "Mon–Fri 8:00am–4:30pm",
    note: "Municipal acceptance facility, Downtown Juneau",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Haines Post Office",
    address: "54 Main St, Haines, AK 99827",
    phone: "(907) 766-2269",
    hours: "Mon–Fri 8:30am–5:00pm",
    note: "Serving Haines Borough residents",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Skagway Post Office",
    address: "649 Broadway St, Skagway, AK 99840",
    phone: "(907) 983-2330",
    hours: "Mon–Fri 9:00am–5:00pm",
    note: "Serving Skagway Municipality residents",
    website: "https://tools.usps.com/find-location.htm",
  },
];

export default function AcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Juneau
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            First-time applicants (and those who can&apos;t mail-renew) need to visit an acceptance facility in person. Here are the main locations near Juneau.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {facilities.map((f, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
                <i className="ri-government-line text-[#1A365D] text-lg"></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{f.name}</h3>
              <p className="text-gray-500 text-xs mb-1 flex items-start gap-1.5">
                <i className="ri-map-pin-line mt-0.5 flex-shrink-0 text-[#F6C344]"></i>
                {f.address}
              </p>
              <p className="text-gray-500 text-xs mb-1 flex items-center gap-1.5">
                <i className="ri-phone-line flex-shrink-0 text-[#F6C344]"></i>
                {f.phone}
              </p>
              <p className="text-gray-500 text-xs mb-1 flex items-center gap-1.5">
                <i className="ri-time-line flex-shrink-0 text-[#F6C344]"></i>
                {f.hours}
              </p>
              <p className="text-gray-500 text-xs mb-1 flex items-center gap-1.5">
                <i className="ri-global-line flex-shrink-0 text-[#F6C344]"></i>
                <a
                  href={f.website}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2"
                >
                  Visit website
                </a>
              </p>
              {f.note && (
                <p className="text-gray-400 text-xs mt-3 pt-3 border-t border-gray-100">{f.note}</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#1A365D] rounded-lg p-6 text-center">
          <p className="text-white/80 text-sm mb-2">
            Skip the acceptance facility line — if you&apos;re eligible to renew by mail, Fast Passport Center handles everything remotely.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap mt-3"
          >
            Check My Eligibility <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}